<template>
    <div>
        <div id="RecuperacionDeContrasena_div" class="w-100 px-5 py-4">
            <div id="TituloRecuperacionDeContrasena_div">
                <h1>RECUPERACIÓN DE CONTRASEÑAS</h1>
                <h3 class="subtitle-text">Encargado de recuperar la contraseña del usuario</h3>
            </div>
            <div class="d-flex row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 padding-div-low">
                    <div class="card-header">
                     <h2>Búsqueda</h2>
                    </div>
                    <div class="area card-body">
                        
                        <h6 class="text-form">Se puede buscar por medio del login del usuario o por medio de la combinacion del nombre del usuario.<br />La busqueda prioritizara la busqueda por medio de login del usuario</h6>
                        <hr />
                        <h6 class="text-form">Login del usuario</h6>
                        <input type="text" class="form-control" v-model="login" placeholder="ejemplo@pjags.gob.mx" />
                        <hr />
                        <div class="form-group">
                            <h6 class="text-form" >Nombre(s)</h6>
                            <input type="text" class="form-control" v-model="nombres" placeholder="Nombre o nombres del usuario" />
                        </div>
                        <div class="form-group">
                            <h6 class="text-form">Primer apellido</h6>
                            <input type="text" class="form-control" v-model="primerApellido" placeholder="Primer apellido del usuario" />
                        </div>
                        <div class="form-group">
                            <h6 class="text-form">Segundo apellido</h6>
                            <input type="text" class="form-control" v-model="segundoApellido" placeholder="Segundo apellido del usuario" />
                        </div>
                        <br />
                        <div id="BuscarUsuario_div" class="text-right">
                            <button class="btn btn-primary overwrapDeBotones" id="buscarUsuario" v-on:click="BuscarUsuarios()">Buscar usuario</button>
                        </div>
                    </div>
                </div>

            <div class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9 padding-div-low">
                <div class="card-header">
                    <h3 v-if="seObtuvoLaContrasena == false">Usuarios</h3>
                </div>
                <div >
                    <div class="area card-body">                        
                        <h6 v-if="seObtuvoLaContrasena == false" class="text-form">Aqui se muestra el listado de usuarios que se obtuvo en base a sus filtros de busqueda.</h6>
                        <h6 v-if="seObtuvoLaContrasena == false" class="text-form">Seleccione una de las filas para poder realizar la busqueda de la contraseña.</h6>
                        <hr v-if="seObtuvoLaContrasena == false" class="text-form"/>
                        <div v-if="seObtuvoLaContrasena == false" class="col-12 table-responsive">
                            <table class="table table-striped table-light table-hover table-bordered" id="tablaDeUsuarios_table">
                                <thead class="table-header-global text-center">
                                    <tr>
                                        <th>ID</th>
                                        <th>Nombre completo</th>
                                        <th>Area</th>
                                        <th>Login</th>
                                        <th>Activo</th>
                                    </tr>
                                </thead>
                                <tbody class="text-justify">
                                    <tr v-if="respuestaDeListadoDeUsuarios.length <= 0" class="text-center" >
                                        <td colspan="5">No existen registros con esas condiciones de busqueda</td>
                                    </tr>
                                    <tr v-else v-for="usuario in respuestaDeListadoDeUsuarios" :key="usuario.IdUsuario" v-on:click="ObtenLaContrasenaDelUsuario(usuario.IdUsuario, usuario.Email)" style="cursor: pointer">
                                        <td class="text-center">{{usuario.IdUsuario}}</td>
                                        <td>{{usuario.Nombre}}{{(usuario.ApellidoPaterno != "" && usuario.ApellidoPaterno != null ? " " + usuario.ApellidoPaterno : "")}}{{(usuario.ApellidoMaterno != "" && usuario.ApellidoMaterno != null ? " " + usuario.ApellidoMaterno : "")}}</td>
                                        <td>{{(usuario.AreaAsignado != null ? usuario.AreaAsignado.Nombre : "Sin área")}}</td>
                                        <td>{{usuario.Email}}</td>
                                        <td class="text-center">{{(usuario.UsuarioActivo == true ? 'Si' : 'No')}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-if="seObtuvoLaContrasena == true">
                            <h3 class="text-form">Información de la cuenta {{emailDelUsuario}}</h3>
                            <h6 style="color: red;">NOTA: Para poder enviar un correo electrónico al usuario, este tiene que ser abogado o personal de Poder Judicial del Estado de Aguascalientes</h6>
                            <hr />
                            <div class="col-12 text-left">
                                <br />
                                <h2 class="text-form">Contraseña: <strong><i>{{respuestaDeLaBusquedaDeUsuario.Contrasena}}</i></strong></h2>
                                <br />
                                <br />
                                <h4 v-html="respuestaDeLaBusquedaDeUsuario.MensajePersonalizado"></h4>
                                <br />
                            </div>
                            <hr />
                            <div id="EnviarCorreo_div" class="text-right">
                                <button class="btn btn-danger overwrapDeBotones" id="cerrarVentanaDeLaContrasena" v-on:click="LimpiarLaSeccionDeContraseña()"><i class="fas fa-times-circle"></i>&nbsp;&nbsp;Cerrar</button>
                                <button class="btn btn-warning overwrapDeBotones" v-if="respuestaDeLaBusquedaDeUsuario.EsAbogado == true" id="actualizarContrasenaDeMajat" v-on:click="ActualizarContrasenaDeMajat()"><i class="fas fa-sync-alt"></i>&nbsp;&nbsp;Actualiza la contraseña de Majat</button>
                                <button class="btn btn-success overwrapDeBotones" v-if="respuestaDeLaBusquedaDeUsuario.SeLePuedeEnviarCorreo == true" id="enviarCorreo" v-on:click="EnviarCorreoElectronico()"><i class="fas fa-envelope"></i>&nbsp;&nbsp;Enviar correo electrónico con contraseña</button>
                            </div>
                        </div>
                    </div>
                </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'

export default {
    data() {
        return {
            enumeraciones,
            login: "",
            nombres: "",
            primerApellido: "",
            segundoApellido: "",
            seObtuvoLaContrasena: false,
            respuestaDeListadoDeUsuarios: [],
            respuestaDeLaBusquedaDeUsuario: {}, 
            emailDelUsuario: null
        }
    }, 
    methods: {
        LimpiarLaSeccionDeContraseña() {
            this.respuestaDeLaBusquedaDeUsuario = {};
            this.seObtuvoLaContrasena = false;
            this.emailDelUsuario = null;
        },
        VerificaQueElUsuarioEsteIngresado: function () {
            let sinLogin = true;
            let sinNombreCompleto = true;

            if (this.login !== "" && this.login !== null) {
                sinLogin = false;
            }

            if (this.nombres !== "" && this.nombres !== null) {
                sinNombreCompleto = false;
            }

            if (this.primerApellido !== "" && this.primerApellido !== null) {
                sinNombreCompleto = false;
            }

            if (this.segundoApellido !== "" && this.segundoApellido !== null) {
                sinNombreCompleto = false;
            }

            if (sinLogin == true && sinNombreCompleto == true) {
                comun.mensajeDeAlerta("No se ha ingresado el login, nombre, primer o segundo apellido del usuario para poder hacer la busqueda.", null, null);
                return false
            }

            return true;
        },
        BuscarUsuarios: function() {
            if(this.VerificaQueElUsuarioEsteIngresado()) {
                comun.SeEstaCargandoInformacion(true);
                this.respuestaDeListadoDeUsuarios = [];
                this.respuestaDeLaBusquedaDeUsuario = {};
                this.seObtuvoLaContrasena = false;

                const parametros = {
                    Login: this.login,
                    Nombres: this.nombres,
                    PrimerApellido: this.primerApellido,
                    SegundoApellido: this.segundoApellido,
                    EsPrueba: this.enumeraciones.EsPrueba
                };

                axios.post(
                    api.conexion + api.SICUS.sistema.usuarios.recuperacionDeContrasena.ObtenUsuarios,
                    parametros,
                    comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                ).then(respuesta => {
                    if(respuesta.data.SiHayError){
                        console.log(respuesta);
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
                    } else {
                        this.respuestaDeListadoDeUsuarios = respuesta.data.Usuarios;
                    }
                    comun.SeEstaCargandoInformacion(false);
                }
                ).catch(excepcion => {
                    console.log(excepcion);
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                    comun.SeEstaCargandoInformacion(false);
                });
            }
        }, 
        ObtenLaContrasenaDelUsuario: function(usuarioId, email) {
            comun.SeEstaCargandoInformacion(true);
            this.respuestaDeLaBusquedaDeUsuario = {};
            this.seObtuvoLaContrasena = false;

            const parametros = {
                UsuarioId: usuarioId,
                EsPrueba: this.enumeraciones.EsPrueba
            };

            axios.post(
                api.conexion + api.SICUS.sistema.usuarios.recuperacionDeContrasena.ObtenLaContrasenaDelUsuario,
                parametros,
                comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
            ).then(respuesta => {
                if(respuesta.data.SiHayError){
                    console.log(respuesta);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
                } else {
                    this.respuestaDeLaBusquedaDeUsuario = respuesta.data;
                    this.seObtuvoLaContrasena = true;
                    this.emailDelUsuario = email;
                }
                comun.SeEstaCargandoInformacion(false);
            }
            ).catch(excepcion => {
                console.log(excepcion);
                comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                comun.SeEstaCargandoInformacion(false);
            });
        }, 
        ActualizarContrasenaDeMajat: function() {
            if(this.VerificaQueSePuedaEnviarUnCorreoElectronicoAlUsuario()) {
                comun.SeEstaCargandoInformacion(true);
            
                const parametros = {
                    UsuarioId: this.respuestaDeLaBusquedaDeUsuario.UsuarioId,
                    EsPrueba: this.enumeraciones.EsPrueba
                };

                axios.post(
                    api.conexion + api.SICUS.sistema.usuarios.recuperacionDeContrasena.ActualizaContrasenaDeMajat,
                    parametros,
                    comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                ).then(respuesta => {
                    if(respuesta.data.SiHayError){
                        console.log(respuesta);
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
                    } else {
                        comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                    }

                    comun.SeEstaCargandoInformacion(false);
                }
                ).catch(excepcion => {
                    console.log(excepcion);
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                    comun.SeEstaCargandoInformacion(false);
                });
            }
        },
        VerificaQueSePuedaEnviarUnCorreoElectronicoAlUsuario: function() {
            if (this.respuestaDeLaBusquedaDeUsuario.UsuarioId === null) {
                comun.mensajeDeAlerta("No existe la informacion para poder enviar un correo electrónico al usuario.", null, null);
                return false
            }

            return true;
        },
        EnviarCorreoElectronico: function() {
            if(this.VerificaQueSePuedaEnviarUnCorreoElectronicoAlUsuario()) {
                comun.SeEstaCargandoInformacion(true);

                const parametros = {
                    UsuarioId: this.respuestaDeLaBusquedaDeUsuario.UsuarioId, 
                    EsPrueba: this.enumeraciones.EsPrueba
                }

                axios.post(
                    api.conexion + api.SICUS.sistema.usuarios.recuperacionDeContrasena.EnviarCorreoElectronico,
                    parametros,
                    comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                ).then(respuesta => {
                    if(respuesta.data.SiHayError){
                        console.log(respuesta);
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
                    } else {
                        comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                    }
                    comun.SeEstaCargandoInformacion(false);
                }
                ).catch(excepcion => {
                    console.log(excepcion);
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                    comun.SeEstaCargandoInformacion(false);
                });
            }
        }
    }
}
</script>

<style scoped>
.table-header-global{
      background-color: #004746;
    }

    .card-body {
        background-color: #bebebc;
        padding: 2em 2em 2em 2em !important;
        border: 1px solid rgb(44, 44, 44);
    }

    .text-form {
        color: black;
    }

    .form-control {
        background-color: white;
        color: rgb(63, 62, 62);
        border: 1px solid #656161 !important;         
    }

    .bottom-style{
      background-color: #004746;
      color: white;
      border: 1px solid rgb(44, 44, 44);
      border-radius: 0px 0px 0px 0px;
    }
    .card-header {
        background-color: #007573;
        border: 1px solid rgb(44, 44, 44);

    }
    .subtitle-text{
        color: #7e7f74;
    }
</style>


// WEBPACK FOOTER //
// src/components/SICUS/Usuarios/RecuperacionDeContrasena/Index.vue